import { cx } from "../../lib/format";

const ENABLED = process.env.REACT_APP_ADS_ENABLED === "true";
const SIZES = { leaderboard: "min-h-[90px]", rectangle: "min-h-[250px]", rail: "min-h-[600px]", inline: "min-h-[120px]" };

export const AdSlot = ({ slot, size = "inline", className = "" }) => {
  if (!ENABLED) return null;
  return (
    <aside aria-label="Advertisement" className={cx("my-10 flex flex-col items-center justify-center rounded-xl border border-dashed border-[#E2E2DC] bg-[#F3F3EE] px-4 py-6 text-center", SIZES[size], className)} data-testid={`ad-slot-${slot}`} data-ad-slot={slot}>
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#7A7A72]">Advertisement</span>
    </aside>
  );
};
